var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import authentication from "@irati/auth";
import { H3 } from "@irati/ui/src/Headings";
import { FormattedMessage, FormattedCurrency, injectIntl } from "@irati/utils/lang";
import { Para } from "@irati/ui/src/Labels";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import TenantWalletTransferType from "@irati/wallet/enums/TenantWalletTransferType";
import { StyledModal, TopCard, GreyCard, InnerCard, BalanceRow, StyledButton } from "./styled";
import ModalHeader from "./ModalHeader";
import RewardWalletRow from "./RewardWalletRow";
var TransferCreditConfirmationPopup = /** @class */ (function (_super) {
    __extends(TransferCreditConfirmationPopup, _super);
    function TransferCreditConfirmationPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransferCreditConfirmationPopup.prototype.render = function () {
        var tenantName = authentication.userTenant().public_name;
        var _a = this.props, handleClose = _a.handleClose, handleRepeatAgain = _a.handleRepeatAgain, show = _a.show, recipients = _a.recipients, totalAmount = _a.totalAmount, remainingAmount = _a.remainingAmount, amount = _a.amount, currency = _a.currency, transferType = _a.transferType;
        return (React.createElement(StyledModal, { show: show, useMobileStyling: false, onHide: handleClose, onExited: handleClose, renderHeader: function () { return React.createElement(ModalHeader, null); } },
            React.createElement(TopCard, null,
                React.createElement(H3, { small: true },
                    React.createElement(FormattedMessage, { id: "wallet.tenant.transferConfirmation.success" })),
                React.createElement(Para, { center: true, large: true },
                    React.createElement(FormattedMessage, { values: {
                            credit: formatCurrency({
                                currencyCode: currency,
                                value: totalAmount,
                                isCents: false
                            }),
                            tenantName: tenantName
                        }, id: transferType === TenantWalletTransferType.TRANSFER
                            ? "wallet.tenant.transferConfirmation.creditTransferred"
                            : "wallet.tenant.transferConfirmation.refundTransferred" }))),
            React.createElement(GreyCard, null,
                React.createElement(InnerCard, null,
                    recipients.map(function (recipient, i) {
                        return React.createElement(RewardWalletRow, { transferType: transferType, recipient: recipient, isFirst: i === 0, amount: amount });
                    }),
                    React.createElement(BalanceRow, null,
                        React.createElement(Para, { bold: true },
                            React.createElement(FormattedMessage, { values: { tenantName: tenantName }, id: transferType === TenantWalletTransferType.TRANSFER
                                    ? "wallet.tenant.transferConfirmation.remainingBalance"
                                    : "wallet.tenant.transferConfirmation.updatedBalance" })),
                        React.createElement(Para, { bold: true },
                            React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: remainingAmount }))),
                    React.createElement(StyledButton, { primary: true, onClick: handleRepeatAgain },
                        React.createElement(FormattedMessage, { id: transferType === TenantWalletTransferType.TRANSFER
                                ? "wallet.tenant.transferConfirmation.transferAgain"
                                : "wallet.tenant.transferConfirmation.refundAgain" }))))));
    };
    TransferCreditConfirmationPopup.defaultProps = {
        pending: false
    };
    return TransferCreditConfirmationPopup;
}(Component));
export default injectIntl(TransferCreditConfirmationPopup);
